<template>
  <Card class="page-summary-card clickable">
    <div class="card-block" v-on:click="openCardPreview">
      <div class="row">
        <div class="col-12">
          <p class="typography--body-3">
            <strong class="typography--color-secondary">{{ index + 1 }}</strong>
            <span class="typography--color-disabled ml-1" v-if="page.is_quiz">{{ $t('common.card.quiz') }}</span>
            <span class="typography--color-disabled ml-1" v-else>{{ $t('common.card.non_quiz') }}</span>
          </p>

          <div class="page-content-container"
               v-bind:class="classBindings">
            <div class="page-image-summary float-left" v-if="hasImage" v-bind:style="{ 'background-image': firstImageSrc }"></div>

            <div class="page-audio-summary" v-if="hasAudio">
              <img src="/static/images/icon-audio.svg" class="align-middle"></img>
              <span class="align-middle typography--body-3">{{ firstAudioDuration | duration }}</span>
            </div>

            <div class="page-video-summary" v-if="hasVideo || hasEmbededVideo">
              <img src="/static/images/icon-video.svg" class="align-middle"></img>
              <span class="align-middle typography--body-3">{{ firstVideoDuration | duration }}</span>
            </div>

            <div class="typography--body-2 typography--pre-line page-content"
                v-html="pageContent">
            </div>
          </div>

        </div>
      </div>
    </div>
  </Card>     
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'page-summary',

    props: [
      'page',
      'index',
    ],

    computed: {
      pageContent() {
        return this.page ? this.page.content : '<p></p>';
      },

      contentImages() {
        return this.page.images.filter(image => (
          this.page.content.indexOf(`data-image-id="${image.id}"`) !== -1
        ));
      },

      hasImage() {
        return this.page.image_count > 0 && this.contentImages.length > 0;
      },

      hasAudio() {
        return this.page.audio_count > 0 && this.page.audios.length > 0;
      },

      hasVideo() {
        return this.page.video_count > 0 && this.page.videos && this.page.videos.length > 0;
      },

      hasEmbededVideo() {
        return this.page.content.match(/<iframe/g) || (this.page.description || '').match(/<iframe/g);
      },

      classBindings() {
        return {
          'has-image': this.hasImage,
          'has-audio': this.hasAudio,
          'has-video': this.hasVideo || this.hasEmbededVideo,
        };
      },

      firstImageSrc() {
        if (this.hasImage) {
          const imageUrl = this.contentImages[0].image_url ||
            this.contentImages[0].small_url ||
            this.contentImages[0].medium_url ||
            this.contentImages[0].original_url;

          return `url('${imageUrl}')`;
        }

        return '';
      },

      firstAudioDuration() {
        if (this.hasAudio) {
          return this.page.audios[0].duration;
        }

        return 0;
      },

      firstVideoDuration() {
        if (this.hasVideo) {
          return this.page.videos[0].duration;
        }

        return 0;
      },
    },

    methods: {
      ...mapActions([
        'setSelectedPreviewPageIndex',
        'setIsPagePreview',
      ]),

      openCardPreview() {
        this.setSelectedPreviewPageIndex(this.index)
          .then(() => (
            this.setIsPagePreview(true)
          ))
          .then(() => {
            this.$root.$emit('show::modal', 'card-preview-modal');
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/library/components/PageSummary.vue